import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestDeleteFaqItem } from "./deleteFaqItem.request";

const useDeleteFaqItem = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchFaqItems = useRefetchQuery(["content-faq"]);

  return useMutation({
    mutationFn: requestDeleteFaqItem,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchFaqItems();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useDeleteFaqItem;
